export default __webpack_public_path__ + "static/media/logo.91239e63.png";